import { render, staticRenderFns } from "./GameRoomPage.vue?vue&type=template&id=d1ab7a0c&scoped=true&"
import script from "./GameRoomPage.vue?vue&type=script&lang=ts&"
export * from "./GameRoomPage.vue?vue&type=script&lang=ts&"
import style0 from "./GameRoomPage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GameRoomPage.vue?vue&type=style&index=1&id=d1ab7a0c&lang=scss&scoped=true&"
import style2 from "./GameRoomPage.vue?vue&type=style&index=2&id=d1ab7a0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ab7a0c",
  null
  
)

export default component.exports